import type { ReactElement } from 'react';
import cx from 'clsx';
import { formatPercentage } from '#utils/format-percentage';
import { ProgressBar } from '../../progress-bar';
import type { AttachmentUploadingProps } from '../types';
import { AttachmentIcon } from '../shared/icon';
import { Layout } from '../shared/layout';
import { Title } from '../shared/title';
import { Subtitle } from '../shared/subtitle';
import styles from './uploading.module.css';

export function AttachmentUploading({
  className,
  endContent,
  icon,
  progress: propsProgress,
  subtitle,
  title,
  ...props
}: AttachmentUploadingProps): ReactElement {
  const progress = Math.round(Math.min(100, Math.max(0, propsProgress)));

  return (
    <Layout
      className={className}
      data-testid="attachment-uploading"
      endContent={endContent}
      icon={<AttachmentIcon icon={icon} />}
      {...props}
    >
      <Title>{title}</Title>

      {subtitle !== undefined ? (
        <Subtitle>{subtitle}</Subtitle>
      ) : (
        <div className={styles.progressContainer}>
          <ProgressBar
            className={styles.progressBar}
            maxValue={100}
            minValue={0}
            type="primary"
            value={progress}
            wrapperClassName={styles.progressBarWrapper}
          />

          <span className={cx(styles.progressLabel, 'body-standard')}>
            {formatPercentage({ percentage: progress })}
          </span>
        </div>
      )}
    </Layout>
  );
}
